import { render, staticRenderFns } from "./TopluTakipTarihi.vue?vue&type=template&id=b97bafaa&scoped=true"
import script from "./TopluTakipTarihi.vue?vue&type=script&lang=ts"
export * from "./TopluTakipTarihi.vue?vue&type=script&lang=ts"
import style0 from "./TopluTakipTarihi.vue?vue&type=style&index=0&id=b97bafaa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b97bafaa",
  null
  
)

export default component.exports